import { Box, Paper, styled, SxProps, Typography, useTheme } from "@mui/material";
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";
import PartList from "../../PartsList/PartList";




export const PropertiesContainer = styled(Box, {
    label: "OrderOfferDetailsPage-PropertiesContainer",
})(({ theme }) => ({

    '> div': {
        padding: 0,

        '> div': {

            '&:first-of-type': {
                //prima colonna

                'button': {
                    color: StyleguideSavioColors.mainBlue,
                    padding: 2,
                },

                '> div': {

                    display: 'flex',
                    alignItems: 'center',
                    height: 27,

                    '&:first-of-type': {
                        '> div:last-child': {  paddingRight: 30, }
                    },

                    '>div:last-child': {
                        paddingLeft: 10,
                    }
                }
            },

            '&:last-child': {
                gridTemplateRows: '1fr 0fr',
                '> div': {
                    '&:first-of-type': {
                        //condizioni di vendita

                        '>h6': {

                            '&:first-of-type': {
                                display: 'flex',
                                alignItems: 'center',
                            }
                        }
                    }
                }
            },

            '> div': {
                //qua sono nelle righe

                'svg:not(button > svg)': {
                    color: StyleguideSavioColors.text.black,
                    marginLeft: 10,
                    '&:hover': {
                        color: StyleguideSavioColors.blue,
                    }
                },
                '> div': {
                    fontSize: 14,

                    '&:first-of-type': {
                        //sono nelle label
                        textTransform: 'uppercase',
                    },

                }
            },

            'h6': {
                color: StyleguideSavioColors.mainBlue + ' !important',
            }
        }

    },

    'h6': {
        fontSize: 14,
        fontWeight: StyleguideSavioFonts.bold,
        textTransform: 'uppercase',
        color: StyleguideSavioColors.text.black,

        '~ div': {

            '>div': {
                '&:first-of-type': {


                    lineHeight: '14px',
                    fontSize: 14,
                    padding: 5,
                    margin: 0,
                    color: StyleguideSavioColors.mainBlue,

                },
                '&:last-child': {
                    fontSize: 14,
                    padding: 3,
                }
            }
        }
    },

}));


export const TablePrice = styled("table", { label: "OfferOrderDetailPage-TablePrice" })(({ theme }) => ({
    textTransform: 'uppercase',


    "tr td:first-of-type": { paddingRight: 10, },
    'tr': {
        '&.totalGrossPrice': {
            color: StyleguideSavioColors.blue,
            fontWeight: StyleguideSavioFonts.bold,
            fontSize: 16,
        },
        '&.totalNetPrice': {
            fontSize: 16,
        },
        '&.totalDiscount': {
            fontSize: 14,
            fontStyle: 'italic',
            'td:last-child': {
                fontStyle: 'normal',
            }
        }
    }
})
);

export const PriceContainer = styled(Paper, { label: "OfferOrderDetailPage-PriceContainer" })(({ theme }) => ({

    

    '+div': {
        //qua siamo dentro la tabella

        //maxHeight: 'calc(100vh - 600px)',
        height: 'auto',
        'thead': {
            'th': {

                '&.manufacturerCompany ': {
                    width: 24,
                },

                '&.qty, &.deliveredQuantity ': {
                    width: 18,
                },
                '&.availabilityDate': {
                    width: 24,
                },
                '&.note': {
                    width: 20,
                },
                '&.grossUnitPrice, &.netTotalPrice ': {
                    width: 34,
                },
                '&.discountPercentage': {
                    width: 28,

                    '+ th': {
                        /** 3dots*/
                        width: 17,
                    }
                },

            }
        },

        'tbody': {
            'tr': {
                'td': {

                    'h6,p,div': {
                        fontSize: 14,
                    },

                    '&:last-child ':{
                        'button':{
                            color: StyleguideSavioColors.mainBlue,
                        }
                    }
                    
                },
                '&:hover':{
                    'td':{
                        '&.discountPercentage ':{
                           
                            textDecoration: 'none !important',
                            'p':{
                                color: StyleguideSavioColors.text.black,
                            }
                        },
                        '&.netTotalPrice, &.grossUnitPrice, &.qty, &.deliveredQuantity   ':{
                            textDecoration: 'none !important',
                        }
                    }
                }
            }
        },
        '> div':{
            '>table + div':{
                display: 'none',
            }
        }
    }
})
);



export const useClasses = () => {
    const theme = useTheme();
    const classes = {
        priceBlock: {
            boxShadow: 'none',
            '> div':{ 
                boxShadow: 'none',
            }
          
        } as SxProps,

    };
    return classes;
};
